module.exports = __webpack_public_path__ + "prod/1.42.2/img/solution-one.1ac564da.png";